module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/paper_mobile-d56271dec4001547528534d1908a3eca.png";